export default __webpack_public_path__ + "static/media/White-Render-Square-removebg-mobile.33cb9256.png";